import createIcon from '../../createIcon';

/**
 * @component @name CurrencyBitcoin
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYuNTYgMTEuNTdDMTcuMTUgMTAuODggMTcuNSA5Ljk4IDE3LjUgOUMxNy41IDcuMTQgMTYuMjMgNS41NyAxNC41IDUuMTNWM0gxMi41VjVIMTAuNVYzSDguNVY1SDUuNVY3SDcuNVYxN0g1LjVWMTlIOC41VjIxSDEwLjVWMTlIMTIuNVYyMUgxNC41VjE5QzE2LjcxIDE5IDE4LjUgMTcuMjEgMTguNSAxNUMxOC41IDEzLjU1IDE3LjcyIDEyLjI3IDE2LjU2IDExLjU3Wk05LjUgN0gxMy41QzE0LjYgNyAxNS41IDcuOSAxNS41IDlDMTUuNSAxMC4xIDE0LjYgMTEgMTMuNSAxMUg5LjVWN1pNMTQuNSAxN0g5LjVWMTNIMTQuNUMxNS42IDEzIDE2LjUgMTMuOSAxNi41IDE1QzE2LjUgMTYuMSAxNS42IDE3IDE0LjUgMTdaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CurrencyBitcoin = createIcon('CurrencyBitcoin', [
  [
    'path',
    {
      d: 'M16.56 11.57C17.15 10.88 17.5 9.98 17.5 9C17.5 7.14 16.23 5.57 14.5 5.13V3H12.5V5H10.5V3H8.5V5H5.5V7H7.5V17H5.5V19H8.5V21H10.5V19H12.5V21H14.5V19C16.71 19 18.5 17.21 18.5 15C18.5 13.55 17.72 12.27 16.56 11.57ZM9.5 7H13.5C14.6 7 15.5 7.9 15.5 9C15.5 10.1 14.6 11 13.5 11H9.5V7ZM14.5 17H9.5V13H14.5C15.6 13 16.5 13.9 16.5 15C16.5 16.1 15.6 17 14.5 17Z',
      key: 'yeo3pi',
    },
  ],
]);

export default CurrencyBitcoin;
